import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Common } from './model/common.model';
@Injectable({
  providedIn: 'root'
})
export class AuthGuardGuard implements CanActivate {
  constructor(private router: Router) { 
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if ((Common.getWithExpiry("CustID") == null || Common.getWithExpiry("CustID") == undefined) && (Common.getWithExpiry("SalesUserID") == null || Common.getWithExpiry("SalesUserID") == undefined)) {
        Common.setWithExpiry("afterloginurl", state.url);
        this.router.navigate(['login'], { queryParams: { returnUrl: state.url } });      
        return false;
      } 
      return true;
  }
  
}
